import { render, staticRenderFns } from "./ProformCustomerOrders.vue?vue&type=template&id=e560490e&"
import script from "./ProformCustomerOrders.vue?vue&type=script&lang=js&"
export * from "./ProformCustomerOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports